//
// # Reflection State
//
// For elements which can be flipped horizontally and/or vertically,
// but cannot be rotated. Primarily text elements.
//

export interface Reflect {
  horiz: boolean;
  vert: boolean;
}
export const Reflect = {
  clone: (ref: Reflect): Reflect => ({ ...ref }),
};
